//var $ = require( 'jquery' );
import 'slick-carousel';

$(function () {
	initSlider();
});

function initSlider() {

	const slider = $('.section-team__members');
	const nextArrow =
		`<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="30" viewBox="0 0 16 30" fill="none">
		<path d="M1.95605 0.998047L15.0001 14.0421" stroke="#F2A234" stroke-width="2" stroke-linecap="round"/>
		<line x1="1" y1="-1" x2="20.2132" y2="-1" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 0 28.2764)" stroke="#F2A234" stroke-width="2" stroke-linecap="round"/>
	  	</svg></button>`;
	const prevArrow =
		`<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="30" viewBox="0 0 16 30" fill="none">
		<path d="M14.0444 28.2764L1.00038 15.2323" stroke="#F2A234" stroke-width="2" stroke-linecap="round"/>
		<line x1="1" y1="-1" x2="20.2132" y2="-1" transform="matrix(-0.707107 0.707107 0.707107 0.707107 16.0005 0.998047)" stroke="#F2A234" stroke-width="2" stroke-linecap="round"/>
	  	 </svg></button>`;

	if (slider.length > 0) {

		slider.slick({
			//lazyLoad: 'ondemand',
			dots: false,
			// rows: 0,
			infinite: true,
			speed: 300,
			slidesToShow: 6,
			slidesToScroll: 1,
			// centerMode: true,
			// mobileFirst: true,
			arrows: true,
			nextArrow: nextArrow,
			prevArrow: prevArrow,
			// cssTransition: true,
			// fade: true,
			// cssEase: "ease",

			responsive: [
				{
					breakpoint: 1440,
					settings: {
						slidesToShow: 5,
						centerMode: false,
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
						centerMode: false,
					}
				},
				{
					breakpoint: 991,
					settings: {
						centerMode: true,
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 767,
					settings: {
						centerMode: true,
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 1,
						centerMode: true,
					}
				}
			]
		});

		var totalSlides = slider.slick('getSlick').slideCount;
		var randomIndex = Math.floor(Math.random() * totalSlides);

		slider.slick('slickGoTo', randomIndex);

		// $('.section-team__members div').removeClass('slick-current');
		// $('.section-team__members div.slick-active:eq(1)').addClass('slick-current');

		// $('.section-team__members').on('afterChange', function (event, slick, currentSlide) {
		// 	$('.section-team__members div').removeClass('slick-current');
		// 	$('.section-team__members div.slick-active:eq(1)').addClass('slick-current');
		// });

		$('.section-team__members div').removeClass('slick-current-active');
		$('.section-team__members div.slick-active:eq(1)').addClass('slick-current-active');

		$('.section-team__members').on('afterChange', function (event, slick, currentSlide) {
			// $('.section-team__members div').removeClass('slick-current-active');
			$('.section-team__members div.slick-active:eq(1)').addClass('slick-current-active');
		});

		$('.section-team__members').on('beforeChange', function (event, slick, currentSlide) {
			$('.section-team__members div').removeClass('slick-current-active');
		
		});
	}
}
